<template>
  <div
    id="page"
    class="page"
  >
    <router-view></router-view>
  </div>
</template>

<script setup></script>

<style scoped>
.page {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>
